/* tslint:disable */
/* eslint-disable */
/**
 * PID Backoffice Gateway, PID External
 * BackOffice Gateway to PartnersID (PID), External.
 *
 * The version of the OpenAPI document: 1.10
 * Contact: veronika.lotnyk@partnersbanka.cz
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// URLSearchParams not necessarily used
// @ts-ignore

// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction,
    type EndpointOptions, // THIS IS CUSTOM
  } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const AcrValueV1 = {
    LOA3: 'loa3',
    LOA2: 'loa2'
} as const;

export type AcrValueV1 = typeof AcrValueV1[keyof typeof AcrValueV1];


/**
 * 
 * @export
 * @interface ActionsV1
 */
export interface ActionsV1 {
    /**
     * 
     * @type {boolean}
     * @memberof ActionsV1
     */
    'blockBankIdentityInNia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActionsV1
     */
    'unblockBankIdentityInNia'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ActionsV1
     */
    'reconcileClientDataInNia'?: boolean;
}
/**
 * 
 * @export
 * @interface AddressV1
 */
export interface AddressV1 {
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'type': AddressV1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'street'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'buildingapartment'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'streetnumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'evidencenumber'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'city': string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'cityarea'?: string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'zipcode': string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof AddressV1
     */
    'ruianReference'?: string;
}

export const AddressV1TypeEnum = {
    UNKNOWN: 'UNKNOWN',
    PERMANENT_RESIDENCE: 'PERMANENT_RESIDENCE',
    SECONDARY_RESIDENCE: 'SECONDARY_RESIDENCE'
} as const;

export type AddressV1TypeEnum = typeof AddressV1TypeEnum[keyof typeof AddressV1TypeEnum];

/**
 * 
 * @export
 * @interface BankIdClientV1
 */
export interface BankIdClientV1 {
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'clientId': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'clientType'?: BankIdClientV1ClientTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'clientProviderName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'clientUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'logoUri': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdClientV1
     */
    'updatedAt': string;
}

export const BankIdClientV1ClientTypeEnum = {
    UNKNOWN: 'UNKNOWN',
    BANK: 'BANK',
    FINANCIAL_COMPANY: 'FINANCIAL_COMPANY',
    AML_COMPANY: 'AML_COMPANY',
    PUBLIC_ENTITY: 'PUBLIC_ENTITY',
    NONPROFIT_ORGANIZATION: 'NONPROFIT_ORGANIZATION',
    OTHER_COMPANY: 'OTHER_COMPANY'
} as const;

export type BankIdClientV1ClientTypeEnum = typeof BankIdClientV1ClientTypeEnum[keyof typeof BankIdClientV1ClientTypeEnum];

/**
 * Results of BankId services and scopes eligibility calculations
 * @export
 * @interface BankIdDetailV1
 */
export interface BankIdDetailV1 {
    /**
     * 
     * @type {boolean}
     * @memberof BankIdDetailV1
     */
    'fetchResult': boolean;
    /**
     * Indicates if user has visible BankId settings in mobile application
     * @type {boolean}
     * @memberof BankIdDetailV1
     */
    'bankIdInMobAppEnabled'?: boolean;
    /**
     * 
     * @type {BankIdServiceEligibilityV1}
     * @memberof BankIdDetailV1
     */
    'bankIdServiceEligibility'?: BankIdServiceEligibilityV1;
    /**
     * 
     * @type {BankIdScopeEligibilityV1}
     * @memberof BankIdDetailV1
     */
    'bankIdScopeEligibility'?: BankIdScopeEligibilityV1;
}
/**
 * @type BankIdEventBaseV1
 * @export
 */
export type BankIdEventBaseV1 = { type: 'CONSENTED_SCOPES' } & BankIdEventConsentedScopesV1 | { type: 'LOGIN' } & BankIdEventLoginV1 | { type: 'NOTIFICATION' } & BankIdEventNotificationV1 | { type: 'PROFILE' } & BankIdEventProfileV1 | { type: 'SIGN' } & BankIdEventSignV1 | { type: 'USER_INFO' } & BankIdEventUserInfoV1;

/**
 * 
 * @export
 * @interface BankIdEventCommonV1
 */
export interface BankIdEventCommonV1 {
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventCommonV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventCommonV1
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BankIdEventConsentedScopesV1
 */
export interface BankIdEventConsentedScopesV1 {
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventConsentedScopesV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventConsentedScopesV1
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BankIdEventLoginV1
 */
export interface BankIdEventLoginV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof BankIdEventLoginV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {Array<BankIdPidUuidAndDeviceNameV1>}
     * @memberof BankIdEventLoginV1
     */
    'pidUuidAndDeviceNames': Array<BankIdPidUuidAndDeviceNameV1>;
    /**
     * 
     * @type {FlowTypeV1}
     * @memberof BankIdEventLoginV1
     */
    'flowType'?: FlowTypeV1;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventLoginV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventLoginV1
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @interface BankIdEventNotificationV1
 */
export interface BankIdEventNotificationV1 {
    /**
     * 
     * @type {Array<BankIdClientV1>}
     * @memberof BankIdEventNotificationV1
     */
    'clients': Array<BankIdClientV1>;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BankIdEventNotificationV1
     */
    'pidUuid': string;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventNotificationV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventNotificationV1
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BankIdEventProfileV1
 */
export interface BankIdEventProfileV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof BankIdEventProfileV1
     */
    'client': BankIdClientV1;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BankIdEventProfileV1
     */
    'pidUuid': string;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventProfileV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventProfileV1
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BankIdEventSignV1
 */
export interface BankIdEventSignV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof BankIdEventSignV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {Array<BankIdPidUuidAndDeviceNameV1>}
     * @memberof BankIdEventSignV1
     */
    'pidUuidAndDeviceNames': Array<BankIdPidUuidAndDeviceNameV1>;
    /**
     * 
     * @type {SignTypeV1}
     * @memberof BankIdEventSignV1
     */
    'signType'?: SignTypeV1;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventSignV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventSignV1
     */
    'createdAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const BankIdEventTypeV1 = {
    CONSENTED_SCOPES: 'CONSENTED_SCOPES',
    LOGIN: 'LOGIN',
    NOTIFICATION: 'NOTIFICATION',
    PROFILE: 'PROFILE',
    SIGN: 'SIGN',
    USER_INFO: 'USER_INFO'
} as const;

export type BankIdEventTypeV1 = typeof BankIdEventTypeV1[keyof typeof BankIdEventTypeV1];


/**
 * 
 * @export
 * @interface BankIdEventUserInfoV1
 */
export interface BankIdEventUserInfoV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof BankIdEventUserInfoV1
     */
    'client': BankIdClientV1;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BankIdEventUserInfoV1
     */
    'pidUuid': string;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdEventUserInfoV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdEventUserInfoV1
     */
    'createdAt': string;
}
/**
 * 
 * @export
 * @interface BankIdInfoResponseV1
 */
export interface BankIdInfoResponseV1 {
    /**
     * 
     * @type {boolean}
     * @memberof BankIdInfoResponseV1
     */
    'eligibleForBankId': boolean;
    /**
     * 
     * @type {Array<BankIdNotEligibleReasonV1>}
     * @memberof BankIdInfoResponseV1
     */
    'notEligibleReasons'?: Array<BankIdNotEligibleReasonV1>;
    /**
     * 
     * @type {BankIdDetailV1}
     * @memberof BankIdInfoResponseV1
     */
    'bankIdDetail': BankIdDetailV1;
    /**
     * 
     * @type {BankIdentityInNiaV2x7}
     * @memberof BankIdInfoResponseV1
     */
    'bankIdInNia': BankIdentityInNiaV2x7;
    /**
     * 
     * @type {ActionsV1}
     * @memberof BankIdInfoResponseV1
     */
    'actions': ActionsV1;
}
/**
 * 
 * @export
 * @interface BankIdLoginDetailV1
 */
export interface BankIdLoginDetailV1 {
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginDetailV1
     */
    'sessionCode': string;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdLoginDetailV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof BankIdLoginDetailV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {Array<BankIdLoginEventV1>}
     * @memberof BankIdLoginDetailV1
     */
    'events': Array<BankIdLoginEventV1>;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginDetailV1
     */
    'eventFilterCreatedAt': string;
    /**
     * 
     * @type {Array<BankIdPidUuidAndDeviceNameV1>}
     * @memberof BankIdLoginDetailV1
     */
    'pidUuidAndDeviceNames': Array<BankIdPidUuidAndDeviceNameV1>;
}
/**
 * 
 * @export
 * @interface BankIdLoginEventV1
 */
export interface BankIdLoginEventV1 {
    /**
     * 
     * @type {number}
     * @memberof BankIdLoginEventV1
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'correlationId': string;
    /**
     * 
     * @type {FlowTypeV1}
     * @memberof BankIdLoginEventV1
     */
    'flowType': FlowTypeV1;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'eventType': BankIdLoginEventV1EventTypeEnum;
    /**
     * 
     * @type {Array<BankIdLoginScopesV1>}
     * @memberof BankIdLoginEventV1
     */
    'scopes': Array<BankIdLoginScopesV1>;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'pidUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'logEventTime': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'failedReason'?: BankIdLoginEventV1FailedReasonEnum;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'verificationInstrument'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'bsi'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginEventV1
     */
    'updatedAt': string;
}

export const BankIdLoginEventV1EventTypeEnum = {
    UNKNOWN: 'UNKNOWN',
    ATTEMPT: 'ATTEMPT',
    ATTEMPT_CANCELED: 'ATTEMPT_CANCELED',
    ATTEMPT_CONFIRMED: 'ATTEMPT_CONFIRMED',
    SUCCEEDED: 'SUCCEEDED',
    FAILED: 'FAILED',
    CANCELED: 'CANCELED'
} as const;

export type BankIdLoginEventV1EventTypeEnum = typeof BankIdLoginEventV1EventTypeEnum[keyof typeof BankIdLoginEventV1EventTypeEnum];
export const BankIdLoginEventV1FailedReasonEnum = {
    UNKNOWN: 'UNKNOWN',
    CLIENT_NOT_FOUND: 'CLIENT_NOT_FOUND',
    OPT_OUT: 'OPT_OUT',
    MISSING_VERIFICATION_INSTRUMENT: 'MISSING_VERIFICATION_INSTRUMENT',
    MISSING_BSI: 'MISSING_BSI'
} as const;

export type BankIdLoginEventV1FailedReasonEnum = typeof BankIdLoginEventV1FailedReasonEnum[keyof typeof BankIdLoginEventV1FailedReasonEnum];

/**
 * 
 * @export
 * @interface BankIdLoginScopesV1
 */
export interface BankIdLoginScopesV1 {
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginScopesV1
     */
    'type'?: BankIdLoginScopesV1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BankIdLoginScopesV1
     */
    'name': string;
}

export const BankIdLoginScopesV1TypeEnum = {
    REQUIRED: 'REQUIRED',
    OPTIONAL: 'OPTIONAL'
} as const;

export type BankIdLoginScopesV1TypeEnum = typeof BankIdLoginScopesV1TypeEnum[keyof typeof BankIdLoginScopesV1TypeEnum];

/**
 * 
 * @export
 * @enum {string}
 */

export const BankIdNotEligibleReasonV1 = {
    AGE_UNDER_LIMIT: 'CLIENT_AGE_UNDER_LIMIT',
    IS_NOT_BANK_CLIENT: 'CLIENT_IS_NOT_BANK_CLIENT',
    HAS_NO_BANK_AIFO: 'CLIENT_HAS_NO_BANK_AIFO'
} as const;

export type BankIdNotEligibleReasonV1 = typeof BankIdNotEligibleReasonV1[keyof typeof BankIdNotEligibleReasonV1];


/**
 * 
 * @export
 * @interface BankIdPidUuidAndDeviceNameV1
 */
export interface BankIdPidUuidAndDeviceNameV1 {
    /**
     * 
     * @type {string}
     * @memberof BankIdPidUuidAndDeviceNameV1
     */
    'deviceName'?: string;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof BankIdPidUuidAndDeviceNameV1
     */
    'pidUuid': string;
}
/**
 * Eligibility calculations results for BankId scopes
 * @export
 * @interface BankIdScopeEligibilityV1
 */
export interface BankIdScopeEligibilityV1 {
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'name': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'email': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'phoneNumber': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'birthdate': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'addresses': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'titles': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'gender': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'birthNumber': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'paymentAccounts': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'birthPlaceNationality': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'maritalStatus': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'idCards': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'legalStatus': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdScopeEligibilityV1
     */
    'verification': boolean;
}
/**
 * 
 * @export
 * @interface BankIdSearchRequestV1
 */
export interface BankIdSearchRequestV1 {
    /**
     * 
     * @type {BankIdEventTypeV1}
     * @memberof BankIdSearchRequestV1
     */
    'eventType'?: BankIdEventTypeV1;
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof BankIdSearchRequestV1
     */
    'bankIdActivityUuid'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdSearchRequestV1
     */
    'clientId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdSearchRequestV1
     */
    'hasAssociatedPidUuid'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BankIdSearchRequestV1
     */
    'deviceName'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdSearchRequestV1
     */
    'hasNullDeviceName'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof BankIdSearchRequestV1
     */
    'eventTimeFrom'?: string;
    /**
     * 
     * @type {string}
     * @memberof BankIdSearchRequestV1
     */
    'eventTimeTo'?: string;
    /**
     * 
     * @type {PageableV1x0}
     * @memberof BankIdSearchRequestV1
     */
    'pageable': PageableV1x0;
    /**
     * 
     * @type {BankIdSearchSortV1}
     * @memberof BankIdSearchRequestV1
     */
    'sort'?: BankIdSearchSortV1;
}


/**
 * 
 * @export
 * @interface BankIdSearchResponseV1
 */
export interface BankIdSearchResponseV1 {
    /**
     * 
     * @type {Array<BankIdEventBaseV1>}
     * @memberof BankIdSearchResponseV1
     */
    'results': Array<BankIdEventBaseV1>;
    /**
     * 
     * @type {PageableResponseV1x0}
     * @memberof BankIdSearchResponseV1
     */
    'pageable': PageableResponseV1x0;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BankIdSearchSortNameV1 = {
    CREATED_AT: 'CREATED_AT'
} as const;

export type BankIdSearchSortNameV1 = typeof BankIdSearchSortNameV1[keyof typeof BankIdSearchSortNameV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const BankIdSearchSortTypeV1 = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;

export type BankIdSearchSortTypeV1 = typeof BankIdSearchSortTypeV1[keyof typeof BankIdSearchSortTypeV1];


/**
 * 
 * @export
 * @interface BankIdSearchSortV1
 */
export interface BankIdSearchSortV1 {
    /**
     * 
     * @type {BankIdSearchSortNameV1}
     * @memberof BankIdSearchSortV1
     */
    'sortField': BankIdSearchSortNameV1;
    /**
     * 
     * @type {BankIdSearchSortTypeV1}
     * @memberof BankIdSearchSortV1
     */
    'sortOrder': BankIdSearchSortTypeV1;
}


/**
 * Eligibility calculations results for BankId services
 * @export
 * @interface BankIdServiceEligibilityV1
 */
export interface BankIdServiceEligibilityV1 {
    /**
     * Indicates if user has enabled BankId in mobile application (BSI (NIA identification) is not null)
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdEnabled': boolean;
    /**
     * Indicates if user is eligible for bankIdConnect service
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdConnect': boolean;
    /**
     * Indicates if user is eligible for bankIdIdentify service
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdIdentify': boolean;
    /**
     * Indicates if user is eligible for bankIdIdentifyPlus service
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdIdentifyPlus': boolean;
    /**
     * Indicates if user is eligible for bankIdIdentifyAML service
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdIdentifyAml': boolean;
    /**
     * Indicates if user is eligible for bankIdSign service
     * @type {boolean}
     * @memberof BankIdServiceEligibilityV1
     */
    'bankIdSign': boolean;
}
/**
 * 
 * @export
 * @interface BankIdentityInNiaV2x7
 */
export interface BankIdentityInNiaV2x7 {
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV2x7
     */
    'fetchResult': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV2x7
     */
    'blocked'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV2x7
     */
    'hasNiaIdentity'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BankIdentityInNiaV2x7
     */
    'hasBankIdentityBlockedInMobApp'?: boolean;
}
/**
 * 
 * @export
 * @interface ClaimsProfileV1
 */
export interface ClaimsProfileV1 {
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'titlePrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'titleSuffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'middleName'?: string;
    /**
     * 
     * @type {GenderV1}
     * @memberof ClaimsProfileV1
     */
    'gender'?: GenderV1;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'birthdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'birthnumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ClaimsProfileV1
     */
    'age'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsProfileV1
     */
    'majority'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'dateOfDeath'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'birthplace'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'birthcountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'primaryNationality'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimsProfileV1
     */
    'nationalities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'maritalstatus'?: string;
    /**
     * 
     * @type {Array<AddressV1>}
     * @memberof ClaimsProfileV1
     */
    'addresses'?: Array<AddressV1>;
    /**
     * 
     * @type {Array<IdCardV1>}
     * @memberof ClaimsProfileV1
     */
    'idcards'?: Array<IdCardV1>;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsProfileV1
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsProfileV1
     */
    'pep'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsProfileV1
     */
    'limitedLegalCapacity'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ClaimsProfileV1
     */
    'paymentAccounts'?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof ClaimsProfileV1
     */
    'updatedAt'?: number;
}


/**
 * 
 * @export
 * @interface ClaimsUserInfoV1
 */
export interface ClaimsUserInfoV1 {
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'preferredUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsUserInfoV1
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {GenderV1}
     * @memberof ClaimsUserInfoV1
     */
    'gender'?: GenderV1;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'birthdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'zoneinfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimsUserInfoV1
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ClaimsUserInfoV1
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof ClaimsUserInfoV1
     */
    'updatedAt'?: number;
}


/**
 * 
 * @export
 * @interface ConsentedScopesEventV1
 */
export interface ConsentedScopesEventV1 {
    /**
     * Unique identifier of the Bank iD activity
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'bankIdActivityUuid': string;
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof ConsentedScopesEventV1
     */
    'client': BankIdClientV1;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'pidUuid': string;
    /**
     * Time when the user consented to the scopes
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'consentedAt': string;
    /**
     * Set of scopes that were consented to by the user
     * @type {Array<string>}
     * @memberof ConsentedScopesEventV1
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {ConsentedScopesStatusV1}
     * @memberof ConsentedScopesEventV1
     */
    'status': ConsentedScopesStatusV1;
    /**
     * Time used for filtering during search for consented scopes events. This time remains the same even when the event moves from ACTIVE to ARCHIVED. For ARCHIVED events, it is the time the original event was updated the last time. For ACTIVE events, it is the time the original event was updated.
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'eventFilterCreatedAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ConsentedScopesEventV1
     */
    'updatedAt': string;
}


/**
 * Current status of the consented scopes
 * @export
 * @enum {string}
 */

export const ConsentedScopesStatusV1 = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED'
} as const;

export type ConsentedScopesStatusV1 = typeof ConsentedScopesStatusV1[keyof typeof ConsentedScopesStatusV1];


/**
 * 
 * @export
 * @interface DocumentObjectV1
 */
export interface DocumentObjectV1 {
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'hash': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'author': string;
    /**
     * 
     * @type {number}
     * @memberof DocumentObjectV1
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'pages': string;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentObjectV1
     */
    'readByEndUser': boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentObjectV1
     */
    'uri': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const FlowTypeV1 = {
    ID: 'BANK_ID',
    ID_SIGN: 'BANK_ID_SIGN',
    ID_Q_SIGN: 'BANK_ID_Q_SIGN'
} as const;

export type FlowTypeV1 = typeof FlowTypeV1[keyof typeof FlowTypeV1];


/**
 * 
 * @export
 * @enum {string}
 */

export const GenderV1 = {
    UNKNOWN: 'UNKNOWN',
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER'
} as const;

export type GenderV1 = typeof GenderV1[keyof typeof GenderV1];


/**
 * 
 * @export
 * @interface IdCardV1
 */
export interface IdCardV1 {
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'type': IdCardV1TypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'country': string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'number': string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'validTo'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'issuer'?: string;
    /**
     * 
     * @type {string}
     * @memberof IdCardV1
     */
    'issueDate'?: string;
}

export const IdCardV1TypeEnum = {
    UNKNOWN: 'UNKNOWN',
    ID: 'ID',
    P: 'P',
    DL: 'DL',
    IR: 'IR',
    VS: 'VS',
    PS: 'PS',
    IX: 'IX',
    IE: 'IE',
    OP: 'OP',
    CA: 'CA'
} as const;

export type IdCardV1TypeEnum = typeof IdCardV1TypeEnum[keyof typeof IdCardV1TypeEnum];

/**
 * 
 * @export
 * @interface MultiDocumentObjectV1
 */
export interface MultiDocumentObjectV1 {
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof MultiDocumentObjectV1
     */
    'priority': number;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'hash': string;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'subject': string;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'language': string;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'created': string;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'author': string;
    /**
     * 
     * @type {number}
     * @memberof MultiDocumentObjectV1
     */
    'size': number;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'pages': string;
    /**
     * 
     * @type {boolean}
     * @memberof MultiDocumentObjectV1
     */
    'readByEndUser': boolean;
    /**
     * 
     * @type {string}
     * @memberof MultiDocumentObjectV1
     */
    'uri': string;
}
/**
 * 
 * @export
 * @interface NotificationEventV1
 */
export interface NotificationEventV1 {
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'type': NotificationEventV1TypeEnum;
    /**
     * 
     * @type {Array<BankIdClientV1>}
     * @memberof NotificationEventV1
     */
    'clients': Array<BankIdClientV1>;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof NotificationEventV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof NotificationEventV1
     */
    'affectedClaims': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'originalEventAt': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'iss': string;
    /**
     * 
     * @type {number}
     * @memberof NotificationEventV1
     */
    'iat': number;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'jti': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'traceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'correlationId': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof NotificationEventV1
     */
    'updatedAt': string;
}

export const NotificationEventV1TypeEnum = {
    UNKNOWN: 'UNKNOWN',
    CLAIMS_UPDATED: 'CLAIMS_UPDATED'
} as const;

export type NotificationEventV1TypeEnum = typeof NotificationEventV1TypeEnum[keyof typeof NotificationEventV1TypeEnum];

/**
 * Pagaeble object used for searching. Returns the state of pagination.
 * @export
 * @interface PageableResponseV1x0
 */
export interface PageableResponseV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageNumber': number;
    /**
     * Number of records per page.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'pageSize': number;
    /**
     * Total number of pages with this page size.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalPages': number;
    /**
     * Total size of all records.
     * @type {number}
     * @memberof PageableResponseV1x0
     */
    'totalSize': number;
}
/**
 * Object for search paging.
 * @export
 * @interface PageableV1x0
 */
export interface PageableV1x0 {
    /**
     * Number of the page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageNumber': number;
    /**
     * Maximum number of records per page.
     * @type {number}
     * @memberof PageableV1x0
     */
    'pageSize': number;
}
/**
 * 
 * @export
 * @interface ProfileEventV1
 */
export interface ProfileEventV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof ProfileEventV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {string}
     * @memberof ProfileEventV1
     */
    'correlationId': string;
    /**
     * 
     * @type {ProfileV1}
     * @memberof ProfileEventV1
     */
    'data': ProfileV1;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof ProfileEventV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileEventV1
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileEventV1
     */
    'traceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileEventV1
     */
    'updatedAt': string;
}
/**
 * Provide detailed information about End-User
 * @export
 * @interface ProfileV1
 */
export interface ProfileV1 {
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'sub': string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'txn': string;
    /**
     * 
     * @type {VerifiedClaimsProfileV1}
     * @memberof ProfileV1
     */
    'verifiedClaims': VerifiedClaimsProfileV1;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'titlePrefix'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'titleSuffix'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'middleName'?: string;
    /**
     * 
     * @type {GenderV1}
     * @memberof ProfileV1
     */
    'gender'?: GenderV1;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'birthdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'birthnumber'?: string;
    /**
     * 
     * @type {number}
     * @memberof ProfileV1
     */
    'age'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileV1
     */
    'majority'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'dateOfDeath'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'birthplace'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'birthcountry'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'primaryNationality'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileV1
     */
    'nationalities'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'maritalstatus'?: ProfileV1MaritalstatusEnum;
    /**
     * 
     * @type {Array<AddressV1>}
     * @memberof ProfileV1
     */
    'addresses'?: Array<AddressV1>;
    /**
     * 
     * @type {Array<IdCardV1>}
     * @memberof ProfileV1
     */
    'idcards'?: Array<IdCardV1>;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'email'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileV1
     */
    'pep'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ProfileV1
     */
    'limitedLegalCapacity'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ProfileV1
     */
    'paymentAccounts'?: Array<string>;
    /**
     * 
     * @type {Array<ProfileV1PaymentAccountsDetailsInner>}
     * @memberof ProfileV1
     */
    'paymentAccountsDetails'?: Array<ProfileV1PaymentAccountsDetailsInner>;
    /**
     * 
     * @type {number}
     * @memberof ProfileV1
     */
    'updatedAt'?: number;
}

export const ProfileV1MaritalstatusEnum = {
    UNKNOWN: 'UNKNOWN',
    COHABITATION: 'COHABITATION',
    MARRIED: 'MARRIED',
    DIVORCED: 'DIVORCED',
    REGISTERED_PARTNERSHIP: 'REGISTERED_PARTNERSHIP',
    REGISTERED_PARTNERSHIP_CANCELED: 'REGISTERED_PARTNERSHIP_CANCELED',
    PARTNERSHIP: 'PARTNERSHIP',
    PARTNERSHIP_CANCELED: 'PARTNERSHIP_CANCELED',
    WIDOWED: 'WIDOWED',
    SINGLE: 'SINGLE'
} as const;

export type ProfileV1MaritalstatusEnum = typeof ProfileV1MaritalstatusEnum[keyof typeof ProfileV1MaritalstatusEnum];

/**
 * 
 * @export
 * @interface ProfileV1PaymentAccountsDetailsInner
 */
export interface ProfileV1PaymentAccountsDetailsInner {
    /**
     * 
     * @type {string}
     * @memberof ProfileV1PaymentAccountsDetailsInner
     */
    'iban'?: string;
    /**
     * 
     * @type {string}
     * @memberof ProfileV1PaymentAccountsDetailsInner
     */
    'currency'?: string;
}
/**
 * 
 * @export
 * @interface SignEventV1
 */
export interface SignEventV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof SignEventV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {Array<string>}
     * @memberof SignEventV1
     */
    'pidUuids': Array<string>;
    /**
     * 
     * @type {SignTypeV1}
     * @memberof SignEventV1
     */
    'signType'?: SignTypeV1;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'txn': string;
    /**
     * 
     * @type {AcrValueV1}
     * @memberof SignEventV1
     */
    'acrValues'?: AcrValueV1;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'responseType'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'uiLocales'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SignEventV1
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {StructuredScopeV1}
     * @memberof SignEventV1
     */
    'structuredScope'?: StructuredScopeV1;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'traceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'requestUri': string;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'idpRequestUri'?: string;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof SignEventV1
     */
    'updatedAt': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const SignTypeV1 = {
    SIGN: 'SIGN',
    Q_SIGN: 'Q_SIGN'
} as const;

export type SignTypeV1 = typeof SignTypeV1[keyof typeof SignTypeV1];


/**
 * 
 * @export
 * @interface StructuredScopeV1
 */
export interface StructuredScopeV1 {
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1
     */
    'certificateProviderName'?: string;
    /**
     * 
     * @type {StructuredScopeV1SignObject}
     * @memberof StructuredScopeV1
     */
    'signObject'?: StructuredScopeV1SignObject;
    /**
     * 
     * @type {DocumentObjectV1}
     * @memberof StructuredScopeV1
     */
    'documentObject'?: DocumentObjectV1;
    /**
     * 
     * @type {StructuredScopeV1DocumentObjects}
     * @memberof StructuredScopeV1
     */
    'documentObjects'?: StructuredScopeV1DocumentObjects;
}
/**
 * 
 * @export
 * @interface StructuredScopeV1DocumentObjects
 */
export interface StructuredScopeV1DocumentObjects {
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1DocumentObjects
     */
    'envelopeName': string;
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1DocumentObjects
     */
    'envelopeHash': string;
    /**
     * 
     * @type {Array<MultiDocumentObjectV1>}
     * @memberof StructuredScopeV1DocumentObjects
     */
    'documents': Array<MultiDocumentObjectV1>;
}
/**
 * 
 * @export
 * @interface StructuredScopeV1SignObject
 */
export interface StructuredScopeV1SignObject {
    /**
     * 
     * @type {Array<StructuredScopeV1SignObjectFieldsInner>}
     * @memberof StructuredScopeV1SignObject
     */
    'fields': Array<StructuredScopeV1SignObjectFieldsInner>;
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1SignObject
     */
    'hash': string;
}
/**
 * 
 * @export
 * @interface StructuredScopeV1SignObjectFieldsInner
 */
export interface StructuredScopeV1SignObjectFieldsInner {
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1SignObjectFieldsInner
     */
    'key': string;
    /**
     * 
     * @type {string}
     * @memberof StructuredScopeV1SignObjectFieldsInner
     */
    'value': string;
    /**
     * 
     * @type {number}
     * @memberof StructuredScopeV1SignObjectFieldsInner
     */
    'priority': number;
}
/**
 * 
 * @export
 * @interface UserInfoEventV1
 */
export interface UserInfoEventV1 {
    /**
     * 
     * @type {BankIdClientV1}
     * @memberof UserInfoEventV1
     */
    'client': BankIdClientV1;
    /**
     * 
     * @type {string}
     * @memberof UserInfoEventV1
     */
    'correlationId': string;
    /**
     * 
     * @type {UserInfoV1}
     * @memberof UserInfoEventV1
     */
    'data': UserInfoV1;
    /**
     * Unique identifier of the client
     * @type {string}
     * @memberof UserInfoEventV1
     */
    'pidUuid': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserInfoEventV1
     */
    'scopes': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UserInfoEventV1
     */
    'traceId'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoEventV1
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoEventV1
     */
    'updatedAt': string;
}
/**
 * 
 * @export
 * @interface UserInfoV1
 */
export interface UserInfoV1 {
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'sub': string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'txn': string;
    /**
     * 
     * @type {VerifiedClaimsUserInfoV1}
     * @memberof UserInfoV1
     */
    'verifiedClaims': VerifiedClaimsUserInfoV1;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'givenName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'familyName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'middleName'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'nickname'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'preferredUsername'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'email'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfoV1
     */
    'emailVerified'?: boolean;
    /**
     * 
     * @type {GenderV1}
     * @memberof UserInfoV1
     */
    'gender'?: GenderV1;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'birthdate'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'zoneinfo'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof UserInfoV1
     */
    'phoneNumber'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfoV1
     */
    'phoneNumberVerified'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UserInfoV1
     */
    'updatedAt'?: number;
}


/**
 * 
 * @export
 * @interface VerificationV1
 */
export interface VerificationV1 {
    /**
     * 
     * @type {string}
     * @memberof VerificationV1
     */
    'trustFramework': VerificationV1TrustFrameworkEnum;
    /**
     * 
     * @type {string}
     * @memberof VerificationV1
     */
    'time'?: string;
    /**
     * 
     * @type {string}
     * @memberof VerificationV1
     */
    'verificationProcess': string;
}

export const VerificationV1TrustFrameworkEnum = {
    UNKNOWN: 'UNKNOWN',
    CZ_AML: 'CZ_AML'
} as const;

export type VerificationV1TrustFrameworkEnum = typeof VerificationV1TrustFrameworkEnum[keyof typeof VerificationV1TrustFrameworkEnum];

/**
 * 
 * @export
 * @interface VerifiedClaimsProfileV1
 */
export interface VerifiedClaimsProfileV1 {
    /**
     * 
     * @type {VerificationV1}
     * @memberof VerifiedClaimsProfileV1
     */
    'verification': VerificationV1;
    /**
     * 
     * @type {ClaimsProfileV1}
     * @memberof VerifiedClaimsProfileV1
     */
    'claims'?: ClaimsProfileV1;
}
/**
 * 
 * @export
 * @interface VerifiedClaimsUserInfoV1
 */
export interface VerifiedClaimsUserInfoV1 {
    /**
     * 
     * @type {VerificationV1}
     * @memberof VerifiedClaimsUserInfoV1
     */
    'verification': VerificationV1;
    /**
     * 
     * @type {ClaimsUserInfoV1}
     * @memberof VerifiedClaimsUserInfoV1
     */
    'claims'?: ClaimsUserInfoV1;
}


/**
 * PidApi - axios parameter creator
 * @export
 */
export const PidApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get client\'s Bank iD info
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankIdInfoV1: async (xCorrelationId: string, pidUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getBankIdInfoV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('getBankIdInfoV1', 'pidUuid', pidUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/pid/{pidUuid}/bankid/info`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD consented scopes event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentedScopesActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getConsentedScopesActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getConsentedScopesActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getConsentedScopesActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-consented-scopes/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD login event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getLoginActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getLoginActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getLoginActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-login/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD notification event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getNotificationActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getNotificationActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getNotificationActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-notification/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD Profile event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getProfileActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getProfileActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getProfileActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-profile/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD Sign event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getSignActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getSignActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getSignActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-sign/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get details about Bank iD User Info event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoActivityV1: async (xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('getUserInfoActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'xPIDUUID' is not null or undefined
            assertParamExists('getUserInfoActivityV1', 'xPIDUUID', xPIDUUID)
            // verify required parameter 'bankIdActivityUuid' is not null or undefined
            assertParamExists('getUserInfoActivityV1', 'bankIdActivityUuid', bankIdActivityUuid)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/events/bank-id-user-info/{bankIdActivityUuid}`
                .replace(`{${"bankIdActivityUuid"}}`, encodeURIComponent(String(bankIdActivityUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }

            if (xPIDUUID != null) {
                localVarHeaderParameter['X-PID-UUID'] = String(xPIDUUID);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {BankIdSearchRequestV1} bankIdSearchRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchActivityV1: async (xCorrelationId: string, pidUuid: string, bankIdSearchRequestV1: BankIdSearchRequestV1, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xCorrelationId' is not null or undefined
            assertParamExists('searchActivityV1', 'xCorrelationId', xCorrelationId)
            // verify required parameter 'pidUuid' is not null or undefined
            assertParamExists('searchActivityV1', 'pidUuid', pidUuid)
            // verify required parameter 'bankIdSearchRequestV1' is not null or undefined
            assertParamExists('searchActivityV1', 'bankIdSearchRequestV1', bankIdSearchRequestV1)
            const localVarPath = `/pid-backofficegateway-pidbankid-external/v1/pid/{pidUuid}/events/bankid-connector/search`
                .replace(`{${"pidUuid"}}`, encodeURIComponent(String(pidUuid)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (xCorrelationId != null) {
                localVarHeaderParameter['X-Correlation-Id'] = String(xCorrelationId);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(bankIdSearchRequestV1, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PidApi - functional programming interface
 * @export
 */
export const PidApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PidApiAxiosParamCreator(configuration)
    return {
        /**
         * Get client\'s Bank iD info
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBankIdInfoV1(xCorrelationId: string, pidUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankIdInfoResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBankIdInfoV1(xCorrelationId, pidUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD consented scopes event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConsentedScopesActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ConsentedScopesEventV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConsentedScopesActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD login event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLoginActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankIdLoginDetailV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLoginActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD notification event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNotificationActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<NotificationEventV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNotificationActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD Profile event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfileActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfileEventV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfileActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD Sign event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSignActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SignEventV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSignActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Get details about Bank iD User Info event
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} xPIDUUID 
         * @param {string} bankIdActivityUuid 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserInfoActivityV1(xCorrelationId: string, xPIDUUID: string, bankIdActivityUuid: string, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserInfoEventV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserInfoActivityV1(xCorrelationId, xPIDUUID, bankIdActivityUuid, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} xCorrelationId Unique identifier of a service request. Standard parameter in Partners integrations. 
         * @param {string} pidUuid 
         * @param {BankIdSearchRequestV1} bankIdSearchRequestV1 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchActivityV1(xCorrelationId: string, pidUuid: string, bankIdSearchRequestV1: BankIdSearchRequestV1, options?: AxiosRequestConfig,
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM  
        ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BankIdSearchResponseV1>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchActivityV1(xCorrelationId, pidUuid, bankIdSearchRequestV1, options);
            const resultLocalVarAxiosArgs = endpointOptions?.updateArgsBeforeRequest ? await endpointOptions.updateArgsBeforeRequest(localVarAxiosArgs, configuration) : localVarAxiosArgs;
            return createRequestFunction(resultLocalVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PidApi - factory interface
 * @export
 */
export const PidApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PidApiFp(configuration)
    return {
        /**
         * Get client\'s Bank iD info
         * @param {PidApiGetBankIdInfoV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBankIdInfoV1(requestParameters: PidApiGetBankIdInfoV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<BankIdInfoResponseV1> {
            return localVarFp.getBankIdInfoV1(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD consented scopes event
         * @param {PidApiGetConsentedScopesActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConsentedScopesActivityV1(requestParameters: PidApiGetConsentedScopesActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ConsentedScopesEventV1> {
            return localVarFp.getConsentedScopesActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD login event
         * @param {PidApiGetLoginActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLoginActivityV1(requestParameters: PidApiGetLoginActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<BankIdLoginDetailV1> {
            return localVarFp.getLoginActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD notification event
         * @param {PidApiGetNotificationActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNotificationActivityV1(requestParameters: PidApiGetNotificationActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<NotificationEventV1> {
            return localVarFp.getNotificationActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD Profile event
         * @param {PidApiGetProfileActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfileActivityV1(requestParameters: PidApiGetProfileActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<ProfileEventV1> {
            return localVarFp.getProfileActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD Sign event
         * @param {PidApiGetSignActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignActivityV1(requestParameters: PidApiGetSignActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<SignEventV1> {
            return localVarFp.getSignActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * Get details about Bank iD User Info event
         * @param {PidApiGetUserInfoActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserInfoActivityV1(requestParameters: PidApiGetUserInfoActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<UserInfoEventV1> {
            return localVarFp.getUserInfoActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {PidApiSearchActivityV1Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchActivityV1(requestParameters: PidApiSearchActivityV1Request, options?: AxiosRequestConfig, 
            endpointOptions?: EndpointOptions, // THIS IS CUSTOM
        ): AxiosPromise<BankIdSearchResponseV1> {
            return localVarFp.searchActivityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.bankIdSearchRequestV1, options, endpointOptions).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getBankIdInfoV1 operation in PidApi.
 * @export
 * @type PidApiGetBankIdInfoV1Request
 */
export type PidApiGetBankIdInfoV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetBankIdInfoV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetBankIdInfoV1
     */
    readonly pidUuid: string
}

/**
 * Request parameters for getConsentedScopesActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetConsentedScopesActivityV1Request
 */
export type PidApiGetConsentedScopesActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetConsentedScopesActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetConsentedScopesActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetConsentedScopesActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for getLoginActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetLoginActivityV1Request
 */
export type PidApiGetLoginActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetLoginActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetLoginActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetLoginActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for getNotificationActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetNotificationActivityV1Request
 */
export type PidApiGetNotificationActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetNotificationActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetNotificationActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetNotificationActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for getProfileActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetProfileActivityV1Request
 */
export type PidApiGetProfileActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetProfileActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetProfileActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetProfileActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for getSignActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetSignActivityV1Request
 */
export type PidApiGetSignActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetSignActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetSignActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetSignActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for getUserInfoActivityV1 operation in PidApi.
 * @export
 * @type PidApiGetUserInfoActivityV1Request
 */
export type PidApiGetUserInfoActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiGetUserInfoActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetUserInfoActivityV1
     */
    readonly xPIDUUID: string

    /**
     * 
     * @type {string}
     * @memberof PidApiGetUserInfoActivityV1
     */
    readonly bankIdActivityUuid: string
}

/**
 * Request parameters for searchActivityV1 operation in PidApi.
 * @export
 * @type PidApiSearchActivityV1Request
 */
export type PidApiSearchActivityV1Request = {
    /**
     * Unique identifier of a service request. Standard parameter in Partners integrations. 
     * @type {string}
     * @memberof PidApiSearchActivityV1
     */
    readonly xCorrelationId: string

    /**
     * 
     * @type {string}
     * @memberof PidApiSearchActivityV1
     */
    readonly pidUuid: string

    /**
     * 
     * @type {BankIdSearchRequestV1}
     * @memberof PidApiSearchActivityV1
     */
    readonly bankIdSearchRequestV1: BankIdSearchRequestV1
}

/**
 * PidApi - object-oriented interface
 * @export
 * @class PidApi
 * @extends {BaseAPI}
 */
export class PidApi extends BaseAPI {
    /**
     * Get client\'s Bank iD info
     * @param {PidApiGetBankIdInfoV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getBankIdInfoV1(requestParameters: PidApiGetBankIdInfoV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getBankIdInfoV1(requestParameters.xCorrelationId, requestParameters.pidUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD consented scopes event
     * @param {PidApiGetConsentedScopesActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getConsentedScopesActivityV1(requestParameters: PidApiGetConsentedScopesActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getConsentedScopesActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD login event
     * @param {PidApiGetLoginActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getLoginActivityV1(requestParameters: PidApiGetLoginActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getLoginActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD notification event
     * @param {PidApiGetNotificationActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getNotificationActivityV1(requestParameters: PidApiGetNotificationActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getNotificationActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD Profile event
     * @param {PidApiGetProfileActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getProfileActivityV1(requestParameters: PidApiGetProfileActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getProfileActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD Sign event
     * @param {PidApiGetSignActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getSignActivityV1(requestParameters: PidApiGetSignActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getSignActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get details about Bank iD User Info event
     * @param {PidApiGetUserInfoActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public getUserInfoActivityV1(requestParameters: PidApiGetUserInfoActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).getUserInfoActivityV1(requestParameters.xCorrelationId, requestParameters.xPIDUUID, requestParameters.bankIdActivityUuid, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PidApiSearchActivityV1Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PidApi
     */
    public searchActivityV1(requestParameters: PidApiSearchActivityV1Request, options?: AxiosRequestConfig,
        endpointOptions?: EndpointOptions, // THIS IS CUSTOM
    ) {
        return PidApiFp(this.configuration).searchActivityV1(requestParameters.xCorrelationId, requestParameters.pidUuid, requestParameters.bankIdSearchRequestV1, options, endpointOptions).then((request) => request(this.axios, this.basePath));
    }
}


